import {
  AttachmentBar,
  AttachmentIcon,
  AttachmentText,
} from "./Attachments.styles"
import { handleDownload } from "../../util/signedDownloads"

export interface Props {
  fileName: string
  signedUrl: string
}

export default function Attachments(props: Props) {
  return (
    <AttachmentBar onClick={() => handleDownload(props.signedUrl)}>
      <AttachmentIcon />
      <AttachmentText>{props.fileName}</AttachmentText>
    </AttachmentBar>
  )
}
